"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PromotionInternalChannel;
(function (PromotionInternalChannel) {
    PromotionInternalChannel["DEFAULT"] = "default";
    PromotionInternalChannel["WX_CHATBOT_SALE"] = "wx-chatbot-sale";
    PromotionInternalChannel["WX_MENU_SALE"] = "wx-menu-sale";
    PromotionInternalChannel["WX_MENU_GROWTH"] = "wx-menu-growth";
    PromotionInternalChannel["WX_SHARE_SALE"] = "wx-share-sale";
    PromotionInternalChannel["WX_SHARE_GROWTH"] = "wx-share-growth";
    PromotionInternalChannel["WX_QR_GROWTH"] = "wx-qr-growth";
    PromotionInternalChannel["WX_QR_GAME_TEST"] = "wx-qr-game-test";
    PromotionInternalChannel["WX_QR_CERTIFICATE"] = "wx-qr-certificate";
    PromotionInternalChannel["WX_GROUP_SALE"] = "wx-group-sale";
    PromotionInternalChannel["WX_POST_SALE"] = "wx-post-sale";
    PromotionInternalChannel["WX_QR_EULER_QUIZ"] = "wx-qr-euler-quiz";
    PromotionInternalChannel["WX_QR_EULER_MATCH_RESULT"] = "wx-qr-euler-match-result";
    PromotionInternalChannel["WX_SHARE_EULER_QUIZ"] = "wx-share-euler-quiz";
    PromotionInternalChannel["WX_SHARE_EULER_MATCH_RESULT"] = "wx-share-euler-match-result";
    PromotionInternalChannel["WX_QR_SLM_SHARE"] = "wx-qr-slm-share";
    PromotionInternalChannel["WX_SHARE_SLM_COUPON"] = "wx-share-slm-coupon";
    PromotionInternalChannel["WX_SHARE_SLM_RELATIONSHIPS"] = "wx-share-slm-relationships";
    PromotionInternalChannel["WX_SHARE_GROUPON_PURCHASE"] = "wx-share-groupon-purchase";
    PromotionInternalChannel["WX_SHARE_C9X_GROUPON_PURCHASE"] = "wx-share-c9x-groupon-purchase";
    PromotionInternalChannel["WX_QR_SLM_POINT_SHARE"] = "wx-qr-slm-point-share";
    PromotionInternalChannel["WX_SHARE_SLM_POINT_COUPON"] = "wx-share-slm-point-coupon";
    PromotionInternalChannel["WX_SHARE_SLM_POINT_RELATIONSHIPS"] = "wx-share-slm-point-relationships";
    PromotionInternalChannel["WX_SHARE_POINT_HOME"] = "wx-share-point-home";
    PromotionInternalChannel["WX_SHARE_C3_SALE"] = "wx-share-c3-sale";
    PromotionInternalChannel["WX_SHARE_C3_SHARE"] = "wx-share-c3-share";
    PromotionInternalChannel["WX_QR_C3_SHARE"] = "wx-qr-c3-share";
    PromotionInternalChannel["WX_CUSTOM_SHARE_C3_QR"] = "wx-custom-share-c3-qr";
    PromotionInternalChannel["WX_CUSTOM_SHARE_C3_SHARE"] = "wx-custom-share-c3-share";
    PromotionInternalChannel["WX_SHARE_C3_GROWTH"] = "wx-share-c3-growth";
    PromotionInternalChannel["WX_QR_C3_GROWTH"] = "wx-qr-c3-growth";
    PromotionInternalChannel["WX_QR_SLM_C9X_SHARE"] = "wx-qr-slm-c9x-share";
    PromotionInternalChannel["WX_SHARE_SLM_C9X_COUPON"] = "wx-share-slm-c9x-coupon";
    PromotionInternalChannel["WX_SHARE_SLM_C9X_RELATIONSHIPS"] = "wx-share-slm-c9x-relationships";
    PromotionInternalChannel["WX_SHARE_C9X_SALE"] = "wx-share-c9x-sale";
    PromotionInternalChannel["WX_SHARE_C3X_SALE"] = "wx-share-c3x-sale";
    PromotionInternalChannel["WX_SHARE_C3X_SHARE"] = "wx-share-c3x-share";
    PromotionInternalChannel["WX_QR_C3X_SHARE"] = "wx-qr-c3x-share";
    PromotionInternalChannel["WX_CUSTOM_SHARE_C3X_QR"] = "wx-custom-share-c3x-qr";
    PromotionInternalChannel["WX_CUSTOM_SHARE_C3X_SHARE"] = "wx-custom-share-c3x-share";
    PromotionInternalChannel["WX_SHARE_C99X_SALE"] = "wx-share-c99x-sale";
    PromotionInternalChannel["WX_SHARE_C99X_GROUPON_PURCHASE"] = "wx-share-c99x-groupon-purchase";
    PromotionInternalChannel["WX_SHARE_SLM_C99X_COUPON"] = "wx-share-slm-c99x-coupon";
    PromotionInternalChannel["WX_QR_SLM_C99X_SHARE"] = "wx-qr-slm-c99x-share";
    PromotionInternalChannel["WX_SHARE_APPLY_FREE_LESSON"] = "wx-share-apply-free-lesson";
    PromotionInternalChannel["WX_APPLY_FREE_LESSON_DOWNLOAD_GUIDE"] = "wx-apply-free-lesson-download-guide";
    PromotionInternalChannel["WX_SHARE_CERTIFICATE"] = "wx-share-certificate";
    PromotionInternalChannel["WX_RESERVATION_C39X_SHARE"] = "wx-reservation-c39x-share";
    PromotionInternalChannel["WX_QR_RESERVATION_C39X"] = "wx-qr-reservation-c39x";
    PromotionInternalChannel["WX_RESERVATION_C39X_CUSTOM_SHARE"] = "wx-reservation-c39x-custom-share";
    PromotionInternalChannel["WX_QR_SLM_DISCOUNT_SHARE_C9X"] = "wx-qr-slm-discount-share-c9x";
    PromotionInternalChannel["WX_SHARE_SLM_DISCOUNT_COUPON_C9X"] = "wx-share-slm-discount-coupon-c9x";
    PromotionInternalChannel["WX_QR_SLM_DISCOUNT_SHARE_C99X"] = "wx-qr-slm-discount-share-c99x";
    PromotionInternalChannel["WX_SHARE_SLM_DOUBLE11_COUPON_C9X"] = "wx-share-slm-double11-coupon-c9x";
    PromotionInternalChannel["WX_QR_SLM_DOUBLE11_SHARE_C9X"] = "wx-qr-slm-double11-share-c9x";
    PromotionInternalChannel["WX_SHARE_SLM_DISCOUNT_COUPON_C99X"] = "wx-share-slm-discount-coupon-c99x";
    PromotionInternalChannel["WX_SHARE_C39X_SALE"] = "wx-share-c39x-sale";
    PromotionInternalChannel["WX_SHARE_C39X_SHARE"] = "wx-share-c39x-share";
    PromotionInternalChannel["WX_QR_C39X_SHARE"] = "wx-qr-c39x-share";
    PromotionInternalChannel["WX_CUSTOM_SHARE_C39X_QR"] = "wx-custom-share-c39x-qr";
    PromotionInternalChannel["WX_CUSTOM_SHARE_C39X_SHARE"] = "wx-custom-share-c39x-share";
    PromotionInternalChannel["WEAPP_SHARE_CERTIFICATE"] = "weapp-share-certificate";
    PromotionInternalChannel["WEAPP_SHARE_GROWTH"] = "weapp-share-growth";
    PromotionInternalChannel["WEAPP_RETURN_FEE_PLUS_SHARE"] = "weapp-return-fee-plus-share";
    PromotionInternalChannel["WEAPP_CLOCK_IN_PLUS_SHARE"] = "weapp-qr-clock-in-plus-share";
    PromotionInternalChannel["WEAPP_QR_GIFT_COURSE_SHARE"] = "weapp-qr-gift-course-share";
    PromotionInternalChannel["WEAPP_QR_SLM_DISCOUNT_SHARE_C9X"] = "weapp-qr-slm-discount-share-c9x";
    PromotionInternalChannel["WEAPP_QR_SLM_CUSTOM_DISCOUNT_SHARE_C99X"] = "weapp-qr-slm-custom_discount-share-c99x";
    PromotionInternalChannel["WEAPP_QR_SLM_CUSTOM_DISCOUNT_SHARE_C9X"] = "weapp-qr-slm-custom_discount-share-c9x";
    PromotionInternalChannel["WX_SHARE_PRE_QUIZ_SHARE"] = "wx-share-pre-quiz-share";
    PromotionInternalChannel["WX_QR_PRE_QUIZ_SHARE"] = "wx-qr-pre-quiz-share";
    PromotionInternalChannel["WX_SHARE_POST_QUIZ_SHARE"] = "wx-share-post-quiz-share";
    PromotionInternalChannel["WX_QR_POST_QUIZ_SHARE"] = "wx-qr-post-quiz-share";
    PromotionInternalChannel["WX_SHARE_PRE_QUIZ"] = "wx-share-pre-quiz";
    PromotionInternalChannel["WX_SHARE_POST_QUIZ"] = "wx-share-post-quiz";
    PromotionInternalChannel["WX_SHARE_QUIZ_RANKING"] = "wx-share-quiz-ranking";
    PromotionInternalChannel["WX_SHARE_PRE_QUIZ_RESULT"] = "wx-share-pre-quiz-result";
    PromotionInternalChannel["WX_SHARE_POST_QUIZ_RESULT"] = "wx-share-post-quiz-result";
    PromotionInternalChannel["WX_SHARE_SALE_C200"] = "wx-share-sale-c200";
    PromotionInternalChannel["WX_SHARE_GROUPON_PURCHASE_C200"] = "wx-share-groupon-purchase-c200";
    PromotionInternalChannel["WX_SHARE_PROMOTION_DESCARTES_GET_COUPON"] = "wx-share-promotion-descartes-get-coupon";
    PromotionInternalChannel["WX_SHARE_PROMOTION_DESCARTES_HOME"] = "wx-share-promotion-descartes-home";
    PromotionInternalChannel["WX_QR_C200_SHARE"] = "wx-qr-share-c200";
    PromotionInternalChannel["WX_CUSTOM_SHARE_C200_SHARE"] = "wx-custom-share-c200-share";
    PromotionInternalChannel["WX_MOMENTS_AD_SHARE"] = "wx-moments-ad-share";
    PromotionInternalChannel["WX_RETURN_FEE_PLUS_SHARE"] = "wx-return-fee-plus-share";
    PromotionInternalChannel["WX_GROWTH_CHECKOUT_SHARE"] = "wx-growth-checkout-share";
    PromotionInternalChannel["WX_SHARE_GIFT_COURSE_SHARE"] = "wx-share-gift-course-share";
    PromotionInternalChannel["WX_RESOURCE_EXCHANGE_SHARE"] = "wx-resource-exchange-share";
    PromotionInternalChannel["WX_REFUND_V4_SHARE"] = "wx-refund-v4-share";
    PromotionInternalChannel["WX_QR_REFUND_V4_SHARE"] = "wx-qr-refund-v4-share";
    PromotionInternalChannel["WX_SHARE_C3_2_SALE"] = "wx-share-c3-2-sale";
    PromotionInternalChannel["WX_SHARE_C3_3_SALE"] = "wx-share-c3-3-sale";
    PromotionInternalChannel["WX_SHARE_C3_2_SHARE"] = "wx-share-c3-2-share";
    PromotionInternalChannel["WX_SHARE_C3_3_SHARE"] = "wx-share-c3-3-share";
    PromotionInternalChannel["WX_SHARE_C3X_2_SALE"] = "wx-share-c3x-2-sale";
    PromotionInternalChannel["WX_SHARE_C3X_3_SALE"] = "wx-share-c3x-3-sale";
    PromotionInternalChannel["WX_SHARE_C3X_2_SHARE"] = "wx-share-c3x-2-share";
    PromotionInternalChannel["WX_SHARE_C3X_3_SHARE"] = "wx-share-c3x-3-share";
    PromotionInternalChannel["WX_SHARE_C39X_2_SALE"] = "wx-share-c39x-2-sale";
    PromotionInternalChannel["WX_SHARE_C39X_3_SALE"] = "wx-share-c39x-3-sale";
    PromotionInternalChannel["WX_SHARE_C39X_2_SHARE"] = "wx-share-c39x-2-share";
    PromotionInternalChannel["WX_SHARE_C39X_3_SHARE"] = "wx-share-c39x-3-share";
    PromotionInternalChannel["WX_SHARE_C349_2_SALE"] = "wx-share-c349-2-sale";
    PromotionInternalChannel["WX_SHARE_C349_3_SALE"] = "wx-share-c349-3-sale";
    PromotionInternalChannel["WX_SHARE_C349_2_SHARE"] = "wx-share-c349-2-share";
    PromotionInternalChannel["WX_SHARE_C349_3_SHARE"] = "wx-share-c349-3-share";
    PromotionInternalChannel["WX_COURSE_EXCHANGE_SHARE"] = "wx-course-exchange-share";
})(PromotionInternalChannel = exports.PromotionInternalChannel || (exports.PromotionInternalChannel = {}));
//# sourceMappingURL=promotion.js.map


//////////////////
// WEBPACK FOOTER
// ../core/dist/src/types/promotion.js
// module id = 1006
// module chunks = 0